
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CellCoordinates } from '../../types/Spreadsheet';
import { RootState } from '../store';

/**
 * The cell currently open for editing, plus an optional seed value (TV1-2358).
 *
 * `initialValue` exists for type-to-edit: pressing a printable key over a focused
 * cell opens the editor ALREADY containing that character. It is carried here
 * rather than written into the row because an edit in progress is not a change
 * yet — Escape has to leave the row exactly as it was, and the change tracker
 * must capture the true pre-edit value as `originalValue` when the edit commits.
 *
 * Optional, so the 30-odd existing `setEditingCell({ rowId, columnId })` call
 * sites are unaffected: a plain `CellCoordinates` still satisfies the payload.
 */
export type EditingCell = CellCoordinates & { initialValue?: string };

interface EditingState {
  editingCell: EditingCell | null;
}

const initialState: EditingState = {
  editingCell: null
};

const editingSlice = createSlice({
  name: 'editing',
  initialState,
  reducers: {
    setEditingCell( state, action: PayloadAction<EditingCell | null> ) {
      state.editingCell = action.payload;
    }
  }
});

export const { setEditingCell } = editingSlice.actions;
export default editingSlice.reducer;

// Selector
export const selectEditingCell = ( state: RootState ) => state.spreadsheet.editing.editingCell;